import { Button, type ButtonProps } from "@chakra-ui/react";
import { ACCENT_GRADIENT } from "src/theme";

/** The app's primary button: a full-width pill with the accent gradient. */
export const GradientButton = ({ background, ...props }: ButtonProps) => (
  <Button
    width="100%"
    height="52px"
    borderRadius="full"
    color="white"
    fontWeight="semibold"
    fontSize="md"
    background={background ?? ACCENT_GRADIENT}
    boxShadow="0 8px 24px rgba(255, 98, 87, 0.25)"
    transition="transform 0.15s, opacity 0.2s"
    _hover={{ opacity: 0.92 }}
    _active={{ transform: "scale(0.97)" }}
    {...props}
  />
);
